import { IServiceAnexo } from "./base/iServiceAnexo";

export default class ClienteAnexoService extends IServiceAnexo {
    constructor() {
        super("ClienteAnexo");
    }
}
